export const accessLevels = {
  user: {},
  manager: {
    isManager: true,
  },
  admin: {
    isAdmin: true,
  },
};

export const colors = [
  '#FFAA35',
  '#B69663',
  '#F88853',
  '#F76B6A',
  '#9C5DA7',
  '#8666E1',
  '#645BD0',
  '#70A7EE',
  '#108AEC',
  '#00C49E',
  '#12B835',
  '#429746',
  '#396D84',
  '#5597B4',
  '#937368',
  '#845B4E',
  '#67C3EB',
  '#2466BC',
  '#3F51B5',
  '#503F86',
  '#7986CB',
  '#B39DDB',
  '#E6A462',
  '#A8B400',
  '#F09795',
  '#B68E96',
  '#8F827B',
  '#A79B8E',
  '#BB6B00',
  '#008F77',
  '#69A083',
  '#8EAAA1',
];

colors.getRandom = function getRandomColor() {
  const randomIndex = Math.floor(Math.random() * (colors.length - 2) + 1);
  return colors[randomIndex];
};

export const colorMigrations = {
  '#02AD26': '#12B835',
  '#FDB34D': '#FFAA35',
  '#9B838C': '#937368',
  '#9577B5': '#8666E1',
  '#EABD00': '#FFAA35',
  '#F6D444': '#FFAA35',
  '#0096E6': '#108AEC',
};

export const TRANSITION_END_EVENTS =
  'transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd';

export const WEEKDAYS = [
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
  { value: 0, label: 'Sunday' },
];

export const SALES_TYPES = {
  default: 'projectedDay',
  override: 'projectedDate',
  actual: 'actualDate',
};

export const BREAK_OPTIONS = [
  { value: null, label: 'None' },
  { value: 10, label: '10min' },
  { value: 15, label: '15min' },
  { value: 20, label: '20min' },
  { value: 30, label: '30min' },
  { value: 45, label: '45min' },
  { value: 60, label: '60min' },
];

export const YOUTUBE_VIDEO_LABOR_COST = 'https://www.youtube.com/embed/aESEXCXT4v8';

export const PRINT_PAGE_SIZES = [
  { label: 'Letter', value: 'letter' },
  { label: 'Legal', value: 'legal' },
  { label: 'Ledger', value: 'ledger' },
  { label: 'A4', value: 'A4' },
  { label: 'A3', value: 'A3' },
];

export const SCHEDULING_CONFLICTS_ABORT = 'scheduling-conflicts-abort';

export const ROLE_DICT = {
  user: 'Employee',
  manager: 'Manager',
  admin: 'Admin',
};

export const TIMECLOCK_NOTIFICATIONS = {
  ALWAYS: 'ALWAYS',
  ONLY_LATE: 'ONLY_LATE',
  NEVER: 'NEVER',
};

export const TIMECLOCK_GEOFENCING_MODES = {
  ONLY_CLOCK_IN: 'ONLY_CLOCK_IN',
  ONLY_CLOCK_OUT: 'ONLY_CLOCK_OUT',
  BOTH: 'BOTH',
};

export const MOBILE_LAYOUT_MAX_WIDTH = 859;

export const LABOR_COST_CALCULATOR_TYPE = {
  US: 'US',
  ICELAND: 'ICELAND',
};

export const SINGLE_SHIFT_LINE_HEIGHT = 14;

export const INTERCOM_AUTOACTIVATE_PERIOD = 7 * 24 * 3600 * 1000;

export const WAGE_TYPES = {
  HOURLY: 'hourly',
  SALARY: 'salary',
};

export const MODAL_CONFIRMATION_STATE_DELAY = 7000;

export const NAVBAR_HEIGHT = 60;

export const PREMIUM_FEATURE_NAMES = {
  multipleAlarms: 'multipleAlarms',
  shiftTasks: 'shiftTasks',
  messages: 'messages',
  timeclock: 'clockIn',
  laborCost: 'laborCost',
  unavailability: 'unavailability',
  reports: 'reports',
  tags: 'tags',
  googleCalendarSync: 'googleCalendarSync',
  usersCanSeeUsersOutsideLocation: 'usersCanSeeUsersOutsideLocation',
  doubleExchange: 'doubleExchange',
  shiftAcceptance: 'shiftAcceptance',
};

export const LARGE_CHAR = String.fromCharCode(999);

export const DATE_FORMATS = {
  'M/d/yy': '3/28/18',
  'M/d/yyyy': '3/28/2018',
  'd/M/yy': '28/3/18',
  'd/M/yyyy': '28/3/2018',
  'yyyy-MM-dd': '2018-03-28',
  'dd-MM-yyyy': '28-03-2018',
  'MM-dd-yyyy': '03-28-2018',
  'MMMM dd, yyyy': 'March 28, 2018',
  'MMM-dd-yyyy': 'Mar-28-2018',
};
